module.exports = __webpack_public_path__ + "img/default.7a695b1e.png";